/**
 * Firebase initialisation (lazy). The web config is public by design.
 */
import { initializeApp, getApps, type FirebaseApp } from "firebase/app";

export const firebaseConfig = {
  apiKey: "AIzaSyDzKUjQp6j80ZZmtyARRlqJd19Xu8XSCDY",
  authDomain: "apps-96adb.firebaseapp.com",
  databaseURL: "https://apps-96adb-default-rtdb.firebaseio.com",
  projectId: "apps-96adb",
  storageBucket: "apps-96adb.firebasestorage.app",
  messagingSenderId: "457727536565",
  appId: "1:457727536565:web:63bb934067cb8c7fce7dfc",
  measurementId: "G-Y5FJKYJP2Y",
};

export const FUNCTIONS_REGION = "europe-west1";

export function getApp(): FirebaseApp {
  return getApps()[0] ?? initializeApp(firebaseConfig);
}
